<template>
  <div class="confirmacao-root" :class="{ 'confirmacao-root--light': !$vuetify.theme.dark }">

    <!-- Top bar -->
    <div class="conf-topbar">
      <img :src="require('@/assets/images/zapermenu.png')" height="32" alt="ZaperMenu" />
    </div>

    <div class="conf-center">
      <div class="conf-card">

        <!-- Ícone de status -->
        <div class="conf-icon" :class="isPending ? 'conf-icon--pending' : 'conf-icon--success'">
          <v-icon size="48" :color="isPending ? 'amber' : 'success'">
            {{ isPending ? 'mdi-clock-outline' : 'mdi-check-circle' }}
          </v-icon>
        </div>

        <h2 class="conf-title">
          {{ isPending ? 'Pagamento em análise' : `Pagamento confirmado! 🎉` }}
        </h2>

        <p class="conf-desc">
          <template v-if="isPending">
            Seu pagamento está sendo processado. Assim que confirmado, você receberá o contato da nossa equipe pelo WhatsApp.
          </template>
          <template v-else>
            Perfeito, <strong>{{ firstName }}</strong>! Sua conta está sendo ativada. Clique no botão abaixo para falar com nossa equipe e iniciar a implementação.
          </template>
        </p>

        <!-- Próximos passos -->
        <div class="conf-steps" v-if="!isPending">
          <div class="conf-step">
            <div class="conf-step__num">1</div>
            <div>
              <strong>Clique em "Falar com a equipe"</strong><br>
              <span>Envie a mensagem pré-pronta pelo WhatsApp</span>
            </div>
          </div>
          <div class="conf-step">
            <div class="conf-step__num">2</div>
            <div>
              <strong>Especialista entra em contato</strong><br>
              <span>Um profissional irá configurar tudo para você</span>
            </div>
          </div>
          <div class="conf-step">
            <div class="conf-step__num">3</div>
            <div>
              <strong>Seu sistema está pronto!</strong><br>
              <span>Cardápio, impressora, QR Code — tudo funcionando</span>
            </div>
          </div>
        </div>

        <!-- Botão WhatsApp -->
        <button class="btn-whatsapp" @click="openWhatsApp">
          <v-icon class="mr-2">mdi-whatsapp</v-icon>
          Falar com a equipe agora
        </button>

        <!-- Info -->
        <p class="conf-info">
          <v-icon small class="mr-1">mdi-clock-outline</v-icon>
          Atendimento das 8h às 22h todos os dias
        </p>

      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import { trackPlan } from '@/utils/track';
import { trackClick } from '@/utils/lpTracker';

const WHATSAPP_NUMBER = '5549988951210';

export default {
  name: 'Confirmacao',

  data: () => ({
    // Dados capturados do store antes de limpar
    leadNome:  '',
    leadPlano: '',
    leadRamo:  '',
  }),

  computed: {
    ...mapState(['selectedPlan', 'quizAnswers']),

    isPending() {
      return this.$route.query.status === 'pending';
    },

    firstName() {
      return this.leadNome.split(' ')[0] || 'você';
    },

    whatsappMessage() {
      return encodeURIComponent(
        `Olá! Acabei de realizar o pagamento do ${this.leadPlano} do ZaperMenu. ` +
        `Meu nome é ${this.leadNome}${this.leadRamo ? ', tenho um(a) ' + this.leadRamo.toLowerCase() : ''} ` +
        `e gostaria de ativar minha conta e iniciar a implementação. 🚀`
      );
    },
  },

  mounted() {
    // Captura os dados do lead antes de limpar o store
    this.leadNome  = this.quizAnswers?.nome   || '';
    this.leadPlano = this.selectedPlan?.label || 'ZaperMenu';
    this.leadRamo  = this.quizAnswers?.ramo   || '';

    // Tracking de compra — evento mais importante do funil
    if (!this.isPending) {
      const transactionId = this.$route.query.id || Date.now().toString();
      trackPlan('Purchase', 'purchase', this.selectedPlan || {}, {
        transaction_id: transactionId,
      });

      // Limpa o localStorage do lead após conversão confirmada
      this.$store.commit('clearLead');
    }
  },

  methods: {
    openWhatsApp() {
      trackClick('Confirmacao - Falar com a equipe agora');
      const isMobile = window.matchMedia('(any-pointer:coarse)').matches;
      const base = isMobile ? 'whatsapp://' : 'https://api.whatsapp.com/';
      window.open(`${base}send?phone=${WHATSAPP_NUMBER}&text=${this.whatsappMessage}`, '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
.confirmacao-root {
  min-height: 100vh;
  background: var(--page-bg, #0a0a0a);
  display: flex;
  flex-direction: column;
}

.conf-topbar {
  padding: 14px 5%;
  background: #000;
  border-bottom: 1px solid rgba(255,255,255,0.08);
}

.conf-center {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 16px;
}

.conf-card {
  background: #111;
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 24px;
  padding: 44px 40px;
  width: 100%;
  max-width: 500px;
  color: #fff;
  text-align: center;

  @media (max-width: 600px) {
    padding: 32px 20px;
  }
}

/* Icon */
.conf-icon {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  &--success {
    background: rgba(35,207,101,0.12);
    border: 2px solid rgba(35,207,101,0.3);
  }

  &--pending {
    background: rgba(255,193,7,0.12);
    border: 2px solid rgba(255,193,7,0.3);
  }
}

.conf-title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 12px;
  line-height: 1.3;
}

.conf-desc {
  font-size: 15px;
  color: rgba(255,255,255,0.6);
  line-height: 1.65;
  margin-bottom: 28px;

  strong { color: #fff; }
}

/* Steps */
.conf-steps {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 28px;
}

.conf-step {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  font-size: 14px;
  color: rgba(255,255,255,0.65);
  line-height: 1.5;

  strong { color: #fff; }

  &__num {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(244,6,18,0.15);
    border: 1px solid rgba(244,6,18,0.3);
    color: #f40612;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

/* WhatsApp button */
.btn-whatsapp {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 15px;
  border-radius: 14px;
  background: #25d366;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  margin-bottom: 14px;
  transition: opacity 0.2s, transform 0.2s;
  animation: pulse-green 2.2s ease-in-out infinite;

  &:hover { opacity: 0.9; transform: translateY(-1px); }
}

@keyframes pulse-green {
  0%, 100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.4); }
  50%       { box-shadow: 0 0 0 10px rgba(37, 211, 102, 0); }
}

.conf-info {
  font-size: 12px;
  color: rgba(255,255,255,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ══════════════════════════════════════
   LIGHT THEME OVERRIDES
══════════════════════════════════════ */
.confirmacao-root--light {
  background: #f0f2f5;

  .conf-topbar {
    background: #fff;
    border-bottom-color: #e5e7eb;
  }

  .conf-card {
    background: #fff;
    border-color: #e5e7eb;
    box-shadow: 0 4px 24px rgba(0,0,0,0.08);
    color: #111827;
  }

  .conf-title { color: #111827; }

  .conf-desc {
    color: #4b5563;
    strong { color: #111827; }
  }

  .conf-step {
    color: #4b5563;
    strong { color: #111827; }
  }

  .conf-info { color: #9ca3af; }
}
</style>
